import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-white whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫屋
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              韩漫屋—您的高清韩国漫画在线阅读平台。下拉式阅读模式，每日更新热门韩漫，免费畅读精彩作品。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">全部分类</Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">热门分类</h4>
            <div className="space-y-2.5">
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">恋爱韩漫</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">奇幻韩漫</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">动作韩漫</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">悬疑韩漫</Link>
              <Link to="/category" className="block text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">搞笑韩漫</Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">联系我们</h4>
            <div className="space-y-2.5">
              <p className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-2"></i>
                contact@hanmanwu.com
              </p>
              <p className="text-sm text-foreground-400">
                <i className="ri-customer-service-2-line mr-2"></i>
                在线客服：工作日 9:00-18:00
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 韩漫屋 HanManWu. 本站所有内容均来自网络，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="whitespace-nowrap">隐私政策</span>
              <span className="whitespace-nowrap">用户协议</span>
              <span className="whitespace-nowrap">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}